import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForConfluenceBuyReverseTrial(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		invoiceableStatus,
		isInReverseTrial,
		isInTrial,
		isInPredunning,
		isInCollection,
		userRoles,
		canAddPaymentDetails,
		canUpgrade,
	} = context;

	return Boolean(
		isInCollection === 'NOT_IN_COLLECTION' &&
		product === 'confluence' &&
		edition === 'premium' &&
		(isInTrial || isInPredunning) &&
		isInReverseTrial &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		(!fg('flymodst-113-fix-confluence-jira-rt-ea-plan-select') ||
			(userRoles?.includes('BILLING_ADMIN') && canAddPaymentDetails && canUpgrade)),
	);
}
